import React, { lazy } from 'react';
import { ZapIcon } from 'lucide-react';
export function PowerShift() {
  return <section className="w-full px-4 py-16 md:py-24 bg-lightBg" data-id="element-223">
      <div className="max-w-6xl mx-auto" data-id="element-224">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-225">
          <div className="order-2 lg:order-1" data-id="element-226">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-primary hover:border-primaryHover transition-all duration-300" data-id="element-227">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9hR1XfqpTLpTSWfsZjSCao/Screenshot_2025-11-01_at_11.35.01_AM.png" alt="mentor profesional trabajando" className="w-full h-auto" loading="lazy" data-id="element-228" />
            </div>
          </div>
          <div className="order-1 lg:order-2 space-y-6" data-id="element-229">
            <div className="flex items-center gap-3 mb-6" data-id="element-230">
              <ZapIcon className="w-8 h-8 md:w-10 md:h-10 text-primary" data-id="element-231" />
              <h2 className="text-[28px] md:text-[40px] font-bold font-poppins text-textDark tracking-tight uppercase" data-id="element-232">
                El Cambio de Identidad
              </h2>
            </div>
            <div className="space-y-5 text-[16px] md:text-[18px] font-inter text-textDark leading-relaxed" data-id="element-233">
              <p data-id="element-234">No nací siendo un Closer de alto valor.</p>
              <p className="text-[24px] md:text-[32px] font-bold font-poppins text-primary tracking-tight leading-[1.2]" data-id="element-235">
                Me convertí en uno.
              </p>
              <div className="bg-dark p-6 rounded-2xl border-2 border-primary/30" data-id="element-236">
                <p className="text-white mb-4 leading-relaxed" data-id="element-237">
                  Como padre inmigrante, enfrenté los mismos miedos que quizás
                  tú sientes ahora.
                </p>
                <p className="text-primary font-bold text-[18px]" data-id="element-238">
                  Pero aprendí que el cambio no viene de desear más... viene de
                  decidir ser más.
                </p>
              </div>
              <p className="text-[18px] md:text-[22px] font-bold font-inter text-textDark" data-id="element-239">
                Hoy no trabajo por horas.{' '}
                <span className="text-primary" data-id="element-240">Creo valor real.</span>
              </p>
              <p className="text-textDark leading-relaxed" data-id="element-241">
                Y si yo pude hacerlo desde cero,{' '}
                <span className="text-primary font-bold text-[20px]" data-id="element-242">
                  tú también puedes.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}